

import React, { Component } from 'react';
import {Card, Row} from 'reactstrap'
import { CloudinaryContext, Image } from 'cloudinary-react';

const configurationManager = require('../../../../utils/config/configurationManager');
const stateManager = require('../../../../utils/state/stateManager');
const stringUtil = require('../../../../utils/string/stringUtil');

class Error extends Component 
{
    render()
    {
        return  <Row className="justify-content-center" style={{marginTop:'100px', marginLeft:'20px', marginRight:'20px'}}>
                    <Card style={{borderRadius: 20, textAlign:'center',  paddingLeft:'20px', paddingRight:'20px', paddingTop:'50px', paddingBottom:'50px'}}>
                    <div style={{textAlign:'center'}}>
                        <CloudinaryContext cloudName={configurationManager.getAppConfig().cdnAppCloudName}>
                            <Image publicId="app/webOrdering/icons/error.png" width="15%" />
                        </CloudinaryContext>
                    </div>
                    <Row className="justify-content-center" style={{marginTop:'15px'}}>
                        <h2>Something wrong here...</h2>
                    </Row>
                    <Row className="justify-content-center" style={{marginTop:'15px'}}>
                        <div className='smallText'>
                            {
                                stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().fatalError)
                                    ? "Sorry, we're having some technical issues (as you can see). We're working on getting it fixed as soon as we can."
                                    : stateManager.getStore().getState().fatalError
                            }
                        </div>
                    </Row>
                    </Card>
                </Row>
        
    }
}

export default Error;